import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FilesService} from 'src/app/services/files.service';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {timeout} from 'rxjs/operators';
import {ErrorHelper} from '../common/ErrorHelper';
import {NotifierService} from 'angular-notifier';

const REGEXP_FILE_NAME = new RegExp('^((meta|image(-ext|-int)(-lhd|-rhd){0,1})-([A-Zx0-9]{16})|static|oneLayer).*\.zip$');

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;

  selectedFiles: FileList;
  validatedFiles: File[];
  progressInfos = [];
  disId: string;

  constructor(
    private filesService: FilesService,
    private notifierService: NotifierService) {
  }

  ngOnInit(): void {
  }

  onClick(): void {
    this.fileInput.nativeElement.click();
  }

  selectFiles(event): void {
    this.progressInfos = [];
    this.validatedFiles = [];

    this.selectedFiles = event.target.files;
    for (let i = 0; i < this.selectedFiles.length; i++) {
      const currentFile = this.selectedFiles.item(i);
      if (!this.validateFile(currentFile.name)) {
        const msg = 'File name ' + currentFile.name + ' do not match the expected format!';
        this.notifierService.notify('error', msg);
      } else {

        this.validatedFiles.push(currentFile);
        this.progressInfos.push({value: 0, fileName: currentFile.name});
        this.disId = this.getIdentifier(currentFile.name);
      }

    }
  }

  upload(): void {
    this.validatedFiles.forEach((file, index) => {
      this.filesService.upload(file)
        .pipe(timeout(60000))
        .subscribe(
          event => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progressInfos[index].value = Math.round(100 * event.loaded / event.total);
            } else if (event instanceof HttpResponse) {
              this.notifierService.notify('success', event.body.message);
              this.disId = this.getIdentifier(file.name);
            }
          },
          error => {
            this.progressInfos[index].value = 0;
            const errorMessage = ErrorHelper.disectError('Could not upload the file: ' + file.name, error);
            this.notifierService.notify('error', errorMessage);
          });
    });
    this.selectedFiles = undefined;
  }

  validateFile(fileName: string): boolean {
    const validFilename = REGEXP_FILE_NAME.test(fileName);
    return validFilename;
  }

  getIdentifier(fileName: string): string {
    const match = REGEXP_FILE_NAME.exec(fileName);
    return match[4];
  }

}
